// features/sidebar/hooks/use-sidebar-state.ts
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Route } from '@/constants';
import { useIsOpportunityAndIsMine } from '@/features/opportunities/hooks';
import { isId } from '@/helpers';

interface SidebarStateReturn {
    path: string;
    isOpportunitiesActive: boolean;
    isBuyingActive: boolean;
    isSellingActive: boolean;
    isMyDealsActive: boolean;
    myDealsOpen: boolean;
    setMyDealsOpen: (open: boolean) => void;
}

export function useSidebarState(): SidebarStateReturn {
    const path = useLocation().pathname;
    const id = path.split('/').pop();
    const isMyOpportunity = useIsOpportunityAndIsMine({ id: isId(id) ? id : null, path }) ?? false;

    const isOpportunitiesActive =
        path === Route.Home || (path.startsWith(Route.Opportunities) && path !== Route.Opportunities && !isMyOpportunity);
    const isBuyingActive = path.startsWith(Route.Buying);
    const isSellingActive = Boolean(path === Route.Selling || (path.startsWith(Route.Selling) && isMyOpportunity));
    const isMyDealsActive = Boolean(isBuyingActive || isSellingActive);

    const [myDealsOpen, setMyDealsOpen] = useState<boolean>(isMyDealsActive);

    useEffect(() => {
        if (isMyDealsActive) setMyDealsOpen(true);
    }, [isMyDealsActive]);

    return {
        path,
        isOpportunitiesActive,
        isBuyingActive,
        isSellingActive,
        isMyDealsActive,
        myDealsOpen,
        setMyDealsOpen,
    };
}
